import React, { useState } from "react";

//material ui imports
import {
  Grid,
  TextField,
  Typography,
  Divider,
  Button,
  Stack,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SaveIcon from "@mui/icons-material/Save";

//project imports
import config from "../../../../config";

//third party imports
import * as Yup from "yup";
import { useFormik } from "formik";
import useAxiosAuth from "../../../../hooks/useAxiosAuth";
import { LoadingButton } from "@mui/lab";

const PaymentForm = (props) => {
  //Constant
  const axiosAuth = useAxiosAuth();
  const { onSave, onCancel, selectedPayment } = props;
  const theme = useTheme();

  //States
  const [loading, setLoading] = useState(false);
  const [isCurrentChecked, setIsCurrentChecked] = useState(
    selectedPayment?.isCurrent
  );
  const paymentModes = [
    { value: "Cash", label: "Cash" },
    { value: "Credit/Debit Card", label: "Credit/Debit Card" },
    { value: "UPI", label: "UPI" },
    { value: "Bank Transfer", label: "Bank Transfer" },
    { value: "Cheque", label: "Cheque" },
  ];
  const formik = useFormik({
    initialValues: {
      id: selectedPayment.id,
      employerId: selectedPayment.employerId,
      details: selectedPayment.details,
      paymentMode: selectedPayment.paymentMode,
      amount: selectedPayment.amount,
      paymentType: selectedPayment.paymentType,
      date: new Date(selectedPayment.date?.toString() + "Z")
        ?.toISOString()
        ?.split("T")[0],
    },
    validationSchema: Yup.object({
      amount: Yup.number()
        .typeError("Amount must be a number")
        .min(1, "Amount can not be 0 or -ve")
        .required("Amount is required"),

      details: Yup.string().max(255, "Must be 255 characters or less"),
    }),
    onSubmit: (values) => {
      values.isCurrent = isCurrentChecked;
      setLoading(true);
      if (selectedPayment.id === 0) {
        axiosAuth
          .post("/api/EmployerPayments", values)
          .then((response) => {
            if (response.status === 200) {
              onSave();
            } else {
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      } else {
        axiosAuth
          .put("/api/EmployerPayments", values)
          .then((response) => {
            if (response.status === 200) {
              onSave();
            } else {
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      }
    },
  });

  return (
    <>
      <Grid container>
        {selectedPayment.id === 0 ? (
          <Stack direction="row" sx={{ marginX: "auto", alignItems: "center" }}>
            <AccountBalanceIcon />

            <Typography
              color={theme.palette.primary.dark}
              variant="h6"
              textAlign="center"
              sx={{ marginLeft: 2 }}
            >
              Add New Payment
            </Typography>
          </Stack>
        ) : (
          <Stack direction="row" sx={{ marginX: "auto", alignItems: "center" }}>
            <AccountBalanceIcon />
            <Typography
              color={theme.palette.primary.dark}
              variant="h6"
              textAlign="center"
              sx={{ marginLeft: 2 }}
            >
              Edit Payment Details
            </Typography>
          </Stack>
        )}
      </Grid>
      <Divider sx={{ marginY: 2 }} />
      <Grid container spacing={3}>
        <Grid item xl={12} lg={12} md={12} sm={12}>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              name="date"
              type="date"
              label="Payment Date"
              onChange={formik.handleChange}
              value={formik.values.date}
              fullWidth
              error={formik.touched.date && Boolean(formik.errors.date)}
              helperText={formik.touched.date && formik.errors.date}
              sx={{ marginBottom: 3 }}
            />
            <TextField
              name="amount"
              label="Amount"
              type="number"
              fullWidth
              value={formik.values.amount}
              onChange={(e) => {
                let value = e.target.value;
                // Remove leading zeroes unless the value is zero
                if (/^0[0-9]+/.test(value)) {
                  value = value?.replace(/^0+/, "");
                }

                // Update formik
                formik.setFieldValue("amount", value);
              }}
              error={formik.touched.amount && Boolean(formik.errors.amount)}
              helperText={formik.touched.amount && formik.errors.amount}
              sx={{ marginBottom: 2 }}
            />
            <FormControl sx={{ marginBottom: 3 }} fullWidth>
              <InputLabel>Payment Mode</InputLabel>
              <Select
                name="paymentMode"
                label="Payment Mode"
                onChange={formik.handleChange}
                value={formik.values.paymentMode}
                error={
                  formik.touched.paymentMode &&
                  Boolean(formik.errors.paymentMode)
                }
                helperText={
                  formik.touched.paymentMode && formik.errors.paymentMode
                }
              >
                {paymentModes.map((options) => (
                  <MenuItem value={options.value}>{options.label}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* <FormControl sx={{ marginBottom: 3 }} fullWidth>
              <InputLabel>Payment Type</InputLabel>
              <Select
                name="paymentType"
                label="Payment Type"
                onChange={formik.handleChange}
                value={formik.values.paymentType}
                error={
                  formik.touched.paymentType &&
                  Boolean(formik.errors.paymentType)
                }
              >
                <MenuItem value={1}>Paid</MenuItem>
                <MenuItem value={2}>Unpaid</MenuItem>
              </Select>
            </FormControl> */}
            <TextField
              name="details"
              label="Detials"
              onChange={formik.handleChange}
              value={formik.values.details}
              fullWidth
              error={formik.touched.details && Boolean(formik.errors.details)}
              helperText={formik.touched.details && formik.errors.details}
              sx={{ marginBottom: 3 }}
            />
            <Divider sx={{ marginBottom: 2 }} />
            <Grid>
              <LoadingButton
                variant="contained"
                type="submit"
                loading={loading}
                loadingPosition="end"
                endIcon={<SaveIcon />}
              >
                Submit
              </LoadingButton>
              <Button
                variant="outlined"
                onClick={onCancel}
                sx={{ marginLeft: 2 }}
              >
                Cancel
              </Button>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </>
  );
};

export default PaymentForm;
